// extracted by mini-css-extract-plugin
export default {"block":"drpDyzJJdpQUgL4zDrJw","info":"jaoHJVh8Ab99tkpMBqGM","features":"UFK3uW84nmNMxnfJsuZZ","feature":"hW82Xa6hNo0nvVtaEraD","title":"Kxa2zTYWpYxs1KMrSDHW"};